/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sort_OldestInputs */

const en_dashboard_sort_oldest = /** @type {(inputs: Dashboard_Sort_OldestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oldest`)
};

const es_dashboard_sort_oldest = /** @type {(inputs: Dashboard_Sort_OldestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más antiguos`)
};

/**
* | output |
* | --- |
* | "Oldest" |
*
* @param {Dashboard_Sort_OldestInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_sort_oldest = /** @type {((inputs?: Dashboard_Sort_OldestInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sort_OldestInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dashboard_sort_oldest(inputs)
	return en_dashboard_sort_oldest(inputs)
});